// @ts-strict-ignore
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { SafeStyle, DomSanitizer } from '@angular/platform-browser';
import { DEFAULT_LANGUAGE } from '../../../../app.constants';
import { TranslationService } from '../../../../services/translation-service';
import { Language } from '../../../../model/enums/language';
import { FormatNumberService } from '../../../../services/format-number.service';

@Component({
    selector: 'app-target-percentage',
    templateUrl: './target-percentage.component.html',
    styleUrls: ['./target-percentage.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TargetPercentageComponent {
  _value: number | undefined;
  @Input()
  set value(v: number | undefined) {
    if (v !== undefined) {
      v = v < 0 ? 0 : v;
    }
    this._value = v;
  }
  @Input() lang: Language = DEFAULT_LANGUAGE;
  @Input() maxFill: boolean;
  @Input() colour: string;
  @Input() showPercentage: boolean = true;

  constructor(
    private sanitizer: DomSanitizer,
    private translationService: TranslationService,
    private formatNumberService: FormatNumberService
  ) {}

  get rightSideTransform(): SafeStyle {
    const rotation = this.getRotation(this._value);
    const transform = `translateX(-100%) rotate(${rotation}deg) `;
    return this.sanitizer.bypassSecurityTrustStyle(transform);
  }

  get leftSideTransform(): SafeStyle {
    let value = this._value;
    if (value !== undefined) {
      value -= 50;
    }
    const rotation = this.getRotation(value);
    const transform = `translateX(100%) rotate(${rotation}deg) `;
    return this.sanitizer.bypassSecurityTrustStyle(transform);
  }

  get arrowImage(): string {
    let img = 'arrow-fletchings';
    if (this._value === undefined) {
      img += '.gray';
    }
    return `/assets/images/board/${img}.svg`;
  }

  get circleClass(): string {
    let cls = 'circle';
    if (this.value === undefined) {
      cls += ' unset';
    }
    return cls;
  }

  get percentValueText(): string | number {
    if (this._value !== undefined) {
      return this.showPercentage
        ? this.translationService.formatAsNonBreakingPercent(this.lang, this._value) || ''
        : this.formatNumberService.formatWithBoardLanguage(this.lang, this._value) || '';
    }
    return '';
  }

  get valueTransform(): SafeStyle {
    // Note that some languages will add a space between the value and the %-sign.
    const length = this.percentValueText.toString().length;
    const scalingFactor = length < 4 ? 1 : length < 6 ? 0.9 : length < 8 ? 0.7 : length < 12 ? 0.6 : 0.5;
    const transform = `scale(${3.3 * scalingFactor}) `;
    return this.sanitizer.bypassSecurityTrustStyle(transform);
  }

  private getRotation(value: number | undefined): number {
    if (value === undefined) {
      return 0;
    }
    if (this.maxFill || value >= 50) {
      return 180;
    }
    if (value <= 0) {
      return 0;
    }
    return (value / 50) * 180;
  }
}
